import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { constrainPoint } from '@fullcalendar/core/internal';
import { OptionSet } from 'src/app/models/OptionSet';
import { Schedule_ep } from 'src/app/models/Schedule_ep';
import { CalendarService } from 'src/app/services/calendar.service';

@Component({
  selector: 'app-schedule-grid',
  templateUrl: './schedule-grid.component.html',
  styleUrls: ['./schedule-grid.component.scss']
})
export class ScheduleGridComponent implements OnInit {

  days: Array<OptionSet> = [{ viewValue: "א'", value: "Sunday" }, { viewValue: "ב'", value: "Monday" },
  { viewValue: "ג'", value: "Tuesday" }, { viewValue: "ד'", value: "Wednesday" }, { viewValue: "ה'", value: "Thursday" },
  { viewValue: "ו'", value: "Friday" }, { viewValue: "ש'", value: "Saturday" }];
  public form: FormGroup;
  @Input() set loading(value: boolean) {
    if (value)
      this.form.disable();
    else this.form.enable();

  }

  initialValues: any;
  isFormDirty: boolean;
  @Output() onFormChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  onOptionClick() {
    this.onFormChange.emit(this.form.dirty)
  }

  constructor(public calendarSvc: CalendarService, private renderer: Renderer2) {
    this.form = new FormGroup({
      Sunday_e: new FormControl(null),
      Sunday_p: new FormControl(null),
      Monday_e: new FormControl(null),
      Monday_p: new FormControl(null),
      Tuesday_e: new FormControl(null),
      Tuesday_p: new FormControl(null),
      Wednesday_e: new FormControl(null),
      Wednesday_p: new FormControl(null),
      Thursday_e: new FormControl(null),
      Thursday_p: new FormControl(null),
      Friday_e: new FormControl(null),
      Friday_p: new FormControl(null),
      Saturday_e: new FormControl(null),
      Saturday_p: new FormControl(null),
    });
  }

  ngOnInit() {
  }

  initForm(schedule: Schedule_ep, initIsufByDefault: boolean) {
    debugger
    this.days.forEach(day => {
      if (day) {
        if (schedule[day.value + '_e'] && initIsufByDefault) {
          var aa = this.calendarSvc.getOption(schedule[day.value + '_e'].value, this.calendarSvc.ScheduleHoursList);
          this.form.controls[day.value + '_e'].setValue(aa.value);
        }
        else {
          this.form.controls[day.value + '_e'].setValue(null);
        }
        if (schedule[day.value + '_p']) {
          var aa = this.calendarSvc.getOption(schedule[day.value + '_p'].value, this.calendarSvc.ScheduleHoursList);
          this.form.controls[day.value + '_p'].setValue(aa.value);
        }
        else {
          this.form.controls[day.value + '_p'].setValue(null);
        }
      }
    });
    this.initialValues = this.form.value;
  }

  clearForm() {
    this.days.forEach(day => {
      if (day) {
        this.form.controls[day.value + '_e'].setValue(null);
        this.form.controls[day.value + '_p'].setValue(null);
      }
    });
  }
  
  resetForm() {
    this.form.reset(this.initialValues);
    console.log("form was reset " + this.form.dirty);
    this.onFormChange.emit(this.form.dirty);
  }

  focusFirstInput() {
    let inputField: HTMLElement = <HTMLElement>document.querySelectorAll('#Sunday_p')[0];
    inputField && inputField.focus();
  }




}

